import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Root = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  isolation: isolate;
`;

export const Scrim = styled.div<{ $visible?: boolean }>`
  position: absolute;
  inset: 0;
  background: var(--color-dim-scrim);
  opacity: 0;
  transition: opacity 0.72s ease-in-out;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  ${(p) =>
    p.$visible &&
    css`
      opacity: 1;
    `}
`;
